export function prefixWithSlash(s: string): string {
  return '/' + s;
}
